import { clone } from 'lodash'
import { Model as BaseModel } from 'vue-api-query'
import { API_URL } from "../config"

export default class Model extends BaseModel {

    // define a base url for a REST API
    baseURL () {
        return API_URL
    }

    // implement a default request method
    request (config) {
        return this.$http.request(config)
    }

    restore() {
        let endpoint = `${this.baseURL()}/${this.resource()}/${this.id}/restore`

        return this.request({
            method: 'PUT',
            url: endpoint,
            data: {},
        }).then(response => {
            return response.data.data
        })
    }

    saveWithRelationshipsIds(relationships = []) {
        return this.hasId() ? this._updateWithRelationshipsIds(relationships) : this._createWithRelationshipsIds(relationships)
    }
    
    _createWithRelationshipsIds(relationships) {
        let self = this._relationshipsToIds(relationships)

        return this.request({
            method: 'POST',
            url: this.endpoint(),
            data: self
        }).then(response => {
            let self = Object.assign(this, response.data)

            return self
        })
    }
    
    _updateWithRelationshipsIds(relationships) {
        let self = this._relationshipsToIds(relationships)

        return this.request({
            method: 'PUT',
            url: this.endpoint(),
            data: self
        }).then(response => {
            let self = Object.assign(this, response.data)

            return self
        })
    }

    _relationshipsToIds(relationships) {
        let self = clone(this)

        if (Array.isArray(relationships)) {
            for (const relationship of relationships) {
                if (self[relationship]) {
                    self[relationship] = this._relationshipToId(self[relationship])
                }
            }
        } else if (typeof relationships === 'string' || relationships instanceof String) {
            if (self[relationships]) {
                self[relationships] = this._relationshipToId(self[relationships])
            }
        }

        return self
    }

    _relationshipToId(model) {
        if (Array.isArray(model)) {
            let ids = model.map(item => {
                return item.id ? item.id : item
            }).filter(Boolean)

            return [...new Set(ids)]
        }

        return model.id
    }
}
